import * as localeDictionary from 'plotly.js/lib/locales/fr';
import React from 'react';
import Plot from 'react-plotly.js';

const DiagrammeCirculaire = ({
  donnees,
  viewobj_json_content,
  dimensionWidth,
  dimensionHeight,
}) => {
  // Data preparation
  const values = donnees.map((courbe) => courbe.y.reduce((a, b) => a + b, 0));
  const labels = donnees.map((courbe) => courbe.prefix);

  // Style processing
  const styleData = viewobj_json_content?.styleData || {};

  // Plot data configuration
  const data = [
    {
      type: 'pie',
      values,
      labels,
      textinfo: 'label+percent',
      insidetextorientation: 'radial',
      ...styleData,
    },
  ];

  // Layout configuration
  const layout = {
    responsive: true,
    width: dimensionWidth || window.innerHeight - 250,
    height: dimensionHeight || window.innerWidth - 165,
    modebar: {
      orientation: 'h',
      bgcolor: 'rgba(0, 0, 0, 0)',
      color: 'black',
      activecolor: '#eeb214',
    },
    margin: { r: 50 },
    ...viewobj_json_content?.layout,
  };

  // Plot configuration
  const config = {
    locales: { fr: localeDictionary },
    locale: 'fr',
    displayModeBar:
      viewobj_json_content === undefined || viewobj_json_content === null
        ? true
        : viewobj_json_content.length === 0 ||
          viewobj_json_content.displayModeBar === true,
    displaylogo: false,
    modeBarButtonsToRemove: [''],
  };

  return <Plot data={data} layout={layout} config={config} />;
};

export default DiagrammeCirculaire;
